"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchHelper = require("../../util/fetchHelper");
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
const resetPassword = async function (customerEmail) {
  let publisherId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const API_URL = (0, _environmentHelper.default)();
  const url = "".concat(API_URL, "/customers/passwords");
  try {
    const res = await (0, _fetchHelper.fetchWithHeaders)(url, {
      method: 'PUT',
      body: JSON.stringify({
        publisherId,
        customerEmail
      })
    });
    const json = await res.json();
    if (json.message) {
      return {
        ...json,
        errors: [json.message]
      };
    }
    return {
      status: res.status,
      ...json
    };
  } catch (error) {
    return {
      errors: [error.message]
    };
  }
};
var _default = exports.default = resetPassword;